module.exports = __webpack_public_path__ + "img/banner.068841a3.png";